import { httpCore } from "configurations/axios";
import {
  CONTABLE_DASHBOARD_FETCH_REQUEST,
  CONTABLE_DASHBOARD_FETCH_SUCCESS,
  CONTABLE_DASHBOARD_FETCH_FAILURE,
  CONTABLE_DASHBOARD_FETCH_RESET,
} from "redux/types/contableTypes";

const API_GET_MODULO_CONTABLE = "/modulo/contable/";

const getErrorMessage = (error, fallbackMessage) =>
  error?.response?.data?.message ||
  error?.response?.data?.apierror?.mensaje ||
  error?.response?.data ||
  error?.message ||
  fallbackMessage;

export const fetchModuloContable = (rucUsuario, anio, mes) => async (dispatch) => {
  dispatch({ type: CONTABLE_DASHBOARD_FETCH_REQUEST });

  try {
    if (!rucUsuario) {
      throw new Error("No se pudo determinar el RUC del usuario.");
    }

    const params = new URLSearchParams();
    if (anio) params.append("anio", anio);
    if (mes) params.append("mes", mes);
    const query = params.toString() ? `?${params.toString()}` : "";

    const response = await httpCore.get(`${API_GET_MODULO_CONTABLE}${rucUsuario}${query}`);

    dispatch({
      type: CONTABLE_DASHBOARD_FETCH_SUCCESS,
      payload: response.data,
    });

    return response.data;
  } catch (error) {
    const message = getErrorMessage(
      error,
      "No se pudo cargar la informacion contable.",
    );

    dispatch({
      type: CONTABLE_DASHBOARD_FETCH_FAILURE,
      payload: message,
    });

    throw error;
  }
};

export const resetModuloContable = () => ({
  type: CONTABLE_DASHBOARD_FETCH_RESET,
});
